import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

const initialState = {
  isMtlsRequired: true,
  mtlsEnabled: false,
  endpoint: ''
}
export const useMtlsCertificateStore = create(
  persist(
    (set) => ({
      ...initialState,
      setIsMtlsRequired: (value) => set({ isMtlsRequired: value }),
      setMtlsEnabled: (value) => set({ mtlsEnabled: value }),
      setEndpoint: (value) => set({ endpoint: value }),
      logout: () => set(initialState)
    }),
    {
      name: 'mtls-required',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
)
